import axios from 'axios';

export function sendFeedback({
  response,
  comment,
  originalQueryKey,
}: {
  response: 'YES' | 'NO' | 'PARTIALLY';
  comment: string;
  originalQueryKey: string;
}) {
  return axios.post('/search_relevance_feedback', {
    response,
    comment,
    original_query_key: originalQueryKey,
  });
}
